<template>
	<BaseCmsPage>
	<Body class="page-checkout-step5" />
		<WebshopCheckoutLayout class="wc-review-order">
			<template #header>
				<WebshopCheckoutHeader :step="5" />
			</template>

			<template #wcCol1>
				<BaseWebshopCheckout v-slot="{urls, cart}">
					<WebshopStep :step="1" :completed="true" />
					<WebshopStep :step="2" :completed="true" />
					<WebshopStep :step="3" :completed="true" />
					

					<BaseWebshopReviewOrderForm class="step5 form form-animated-label ajax_siteform ajax_siteform_loading step5-form" v-slot="{fields, customer, shipping, payment, meta, loading, orderErrors, total}">
						<div class="checkout-col">
							<div class="wc-step-col1-cnt">
								<div class="col-cont">
									<WebshopStep :step="4" :title="true" />

									<div class="customer-details customer-details-first">
										<div class="review-order-title">
											<BaseCmsLabel code="step1" tag="span" /> <NuxtLink :to="urls.webshop_customer" class="review-order-edit"><BaseCmsLabel code="change_edit_step" tag="span" class="label" /></NuxtLink>
										</div>
										<p v-if="customer?.first_name || customer?.last_name">{{ customer.first_name }} {{ customer.last_name }}</p>
										<p v-if="customer?.oib">{{ customer.oib }}</p>
										<p v-if="customer?.address?.street">{{ customer.address.street }}</p>
										<p v-if="customer?.address?.zipcode || customer?.address?.city">{{ customer.address.zipcode }} {{ customer.address.city }}</p>
										<p v-if="customer?.phone">{{ customer.phone }}</p>
										<p v-if="customer?.address?.country_name">, {{ customer.address.country_name }}</p>
										<p v-if="customer?.email">{{ customer.email }}</p>
										<p v-if="customer?.message">{{ customer.message }}</p>
										
										<div class="global-error" v-if="orderErrors?.customer && !loading"><BaseCmsLabel :code="orderErrors.customer" /></div>
									</div>

									<template v-if="customer?.b_first_name">
										<div class="customer-details">
											<div class="review-order-title">
												<BaseCmsLabel code="customer_shipping" tag="span" /> <NuxtLink :to="urls.webshop_customer" class="review-order-edit"><BaseCmsLabel code="change_edit_step" tag="span" class="label" /></NuxtLink>
											</div>
											<p v-if="customer?.b_first_name || customer?.b_last_name">{{ customer.b_first_name }} {{ customer.b_last_name }}</p>
											<p v-if="customer?.b_oib">{{ customer.b_oib }}</p>
											<p v-if="customer?.b_address?.b_street">{{ customer.b_address.b_street }}</p>
											<p v-if="customer?.b_address?.b_zipcode || customer?.b_address?.b_city">{{ customer.b_address.b_zipcode }} {{ customer.b_address.b_city }}</p>
											<p v-if="customer?.b_address?.b_country_name">, {{ customer.b_address.b_country_name }}</p>
											<p v-if="customer?.b_phone">{{ customer.b_phone }}</p>
											<p v-if="customer?.b_email">{{ customer.b_email }}</p>
											<p v-if="customer?.b_message">{{ customer.b_message }}</p>
										</div>
									</template>
									<div v-else class="customer-details">
										<div class="review-order-title">
											<BaseCmsLabel code="customer_shipping" tag="span" /> <NuxtLink :to="urls.webshop_customer" class="review-order-edit"><BaseCmsLabel code="change_edit_step" tag="span" class="label" /></NuxtLink>
										</div>
										<BaseCmsLabel code="shipping_same_as_customer" tag="p" />
									</div>

									<div class="customer-details" v-if="customer?.b_company_oib">
										<div class="review-order-title">
											<BaseCmsLabel code="customer_r1" tag="span" /> <NuxtLink :to="urls.webshop_customer" class="review-order-edit"><BaseCmsLabel code="change_edit_step" tag="span" class="label" /></NuxtLink>
										</div>
										<p><BaseCmsLabel code="company_name" />: {{ customer.b_company_name }}</p>
										<p><BaseCmsLabel code="company_oib" />: {{ customer.b_company_oib }}</p>
										<p><BaseCmsLabel code="company_address" />: {{ customer.b_company_address }}</p>
									</div>

									<div class="customer-details customer-details-shipping">
										<div class="review-order-title">
											<BaseCmsLabel code="shipping" tag="span" /> <NuxtLink :to="urls.webshop_shipping" class="review-order-edit"><BaseCmsLabel code="change_edit_step" tag="span" class="label" /></NuxtLink>
										</div>
										<p>{{ shipping?.title }}</p>
										<div v-if="shipping?.description" class="shipping_info" v-html="shipping.description"></div>
										<div class="global-error" v-if="orderErrors?.shipping && !loading"><BaseCmsLabel :code="orderErrors.shipping" /></div>
									</div>

									<div class="customer-details">
										<div class="review-order-title">
											<BaseCmsLabel code="payment" tag="span" /> <NuxtLink :to="urls.webshop_payment" class="review-order-edit"><BaseCmsLabel code="change_edit_step" tag="span" class="label" /></NuxtLink>
										</div>
										<p>{{ payment?.title }}</p>
										<div class="global-error" v-if="orderErrors?.payment && !loading"><BaseCmsLabel :code="orderErrors.payment" /></div>
									</div>

									<div class="customer-details customer-details-last" v-if="total">
										<BaseCmsLabel code="customer_total" class="review-order-title" tag="div" />
										<p><BaseUtilsFormatCurrency :price="total.total" /></p>
									</div>

									<div class="section-accept-terms">
										<template v-if="fields">
											<div class="webshop-alert-terms" v-show="acceptTermsAlert"><BaseCmsLabel code="terms_error" tag="span" /></div>
											<div class="webshop-accept-terms-cnt">
												<div v-for="(field,index) in fields" :key="field.name" class="webshop_accept_terms webshop-accept-terms" :class="'webshop-accept-terms'+ index" v-interpolation>
													<span class="wc-accept-terms-tooltip" :class="'webshop-accept-terms'+ index"><BaseCmsLabel code="terms_required" /></span>
													<BaseFormField :item="field" v-slot="{errorMessage}">
														<BaseFormInput @click="checkAlert" />
														<template v-if="field.name == 'accept_terms'">
															<BaseCmsLabel tag="label" :for="field.name" code="accept_terms_webshop" />
														</template>
														<template v-if="field.name == 'accept_terms_2'">
															<BaseCmsLabel tag="label" :for="field.name" code="accept_terms_2_webshop" />
														</template>
														<span class="field_error error" v-show="errorMessage" v-html="errorMessage" />
													</BaseFormField>
												</div>
											</div>
										</template>

										<button :class="['btn btn-primary btn-final-payment', acceptTermsAlert ? 'not-checked1 not-checked2' : 'accepted', loading && 'loading']" type="submit" :disabled="!meta?.valid || loading" v-if="!orderErrors">
											<UiLoader v-if="loading" />
											<BaseCmsLabel code="confirm_order2" tag="span" />
										</button>
									</div>
								</div>
							</div>
						</div>
					</BaseWebshopReviewOrderForm>

					<WebshopCheckoutTracking v-if="cart?.parcels[0]?.items?.length" step="5" :cart="cart" />
				</BaseWebshopCheckout>
			</template>
		</WebshopCheckoutLayout>
	</BaseCmsPage>
</template>

<script setup>
	const acceptTerms = ref(false);
	const acceptTerms2 = ref(false);
	const finishOrderBtn = ref(false);
	function checkAlert(e) {
		if (e.target.name == 'accept_terms') acceptTerms.value = e.target.checked;
		if (e.target.name == 'accept_terms_2') acceptTerms2.value = e.target.checked;
	}

	// show/hide alert
	const acceptTermsAlert = computed(() => {
		return acceptTerms.value && acceptTerms2.value ? false : true;
	});

	// show/hide alert on page load
	onMounted(() => {
		const acceptTermsCheckbox = document.querySelector('[name="accept_terms"]');
		if (acceptTermsCheckbox) acceptTerms.value = acceptTermsCheckbox?.checked;

		const acceptTerms2Checkbox = document.querySelector('[name="accept_terms_2"]');
		if (acceptTerms2Checkbox) acceptTerms2.value = acceptTerms2Checkbox?.checked;
	});

</script>

<style lang="less" scoped>
	.customer-details{
		padding: 0 0 15px; position: relative; 
		p{font-size: 18px; line-height: 23px; padding-bottom: 0; font-weight: 300;}
		.c-total-cnt{display:none !important;}
		.cart-total{display: block !important; padding: 0; margin: 0; border-top: 0; 
			.w-totals-label{display: none}
			.w-totals-value{display: block; font-size: 18px; line-height: 23px; text-align: left; width: 100%; font-weight: 300; color: var(--textColor);}
		}
		.shipping_info, .payment_info{padding: 0;}

		@media (max-width: @t){
			padding-bottom: 12px;
			p{font-size: 16px; line-height: 21px;}
			.cart-total .w-totals-value{font-size: 16px; line-height: 21px;}
		}
		@media (max-width: @tp){
			padding-bottom: 10px;
			p{font-size: 16px; line-height: 22px;}
			.cart-total .w-totals-value{font-size: 16px; line-height: 22px;}
		}
	}
	.shipping_info,.payment_info{
		font-size: 16px; line-height: 22px; padding-left: 34px; padding-top: 3px; font-weight: 300;
		@media (max-width: @t){font-size: 15px; line-height: 21px; padding-left: 32px;}
		@media (max-width: @tp){font-size: 14px; line-height: 18px; padding-left: 30px;}
	}
	.review-order-title{
		font-size: 18px; line-height: 23px; padding-bottom: 5px; font-weight: bold;
		@media (max-width: @t){font-size: 16px; line-height: 21px; padding-bottom: 4px;}
		@media (max-width: @tp){font-size: 16px; line-height: 22px;}
		@media (max-width: @m){color: var(--primaryColor);}
	}
	.review-order-edit{font-size: 14px; line-height: 20px; margin-left: 10px; padding-top: 0; position: relative; text-underline-offset: 2px;
		@media(min-width: @h){
			&:hover{text-decoration: none;}
		}
		@media (max-width: @t){font-size: 13px; line-height: 17px; margin-left: 8px;}
		@media (max-width: @tp){margin-left: 7px;}
	}

	.customer-details-shipping{
		p{padding-bottom: 0;}
	}
	

	//TERMS
	.section-accept-terms{
		@media (max-width: @m){padding: 0 0 30px;}
	}
	.webshop-alert-terms{
		background: var(--primaryColor); min-height: 35px; color: white; font-size: 14px; line-height: 18px; padding: 9px 45px 9px 15px; position: relative; margin-top: 10px; border-radius: 2px;
		&:before{.pseudo(6px,6px); left: 7px; background: var(--primaryColor); transform: rotate(45deg); bottom: -3px;}
		&:after{.pseudo(auto,auto); .icon-danger-white; font: 18px/18px var(--fonti); color: white; right: 15px; top: 9px;}
		@media (max-width: @t){
			padding-right: 15px;
			&:after{display: none;}
			.error{margin-left: 15px;}
		}
		@media (max-width: @tp){
			font-size: 13px; line-height: 16px;
			.error{margin-left: 11px;}
		}
		@media (max-width: @m){
			margin-top: 12px; padding-right: 40px; border-radius: unset; width: calc(~"100% - -30px"); margin-left: -15px;
			&:before{left: 21px;}
			&:after{display: block; top: 50%; margin-top: -10px;}
		}
	}
	.webshop-accept-terms-cnt{
		padding-top: 15px;
		@media (max-width: @t){padding-top: 13px;}
		@media (max-width: @tp){padding-top: 8px;}
	}
	.webshop-accept-terms{position: relative; margin-bottom: 0;
		input[type=checkbox]+label{padding-left: 34px; font-size: 16px; line-height: 22px;}
		.error{margin-left: 10px;}
		@media (max-width: @t){
			input[type=checkbox]+label{padding-left: 32px; font-size: 14px; line-height: 20px;}
		}
		@media (max-width: @tp){
			input[type=checkbox]+label{padding-left: 30px; font-size: 13px;}
			.error{margin-left: 16px; padding-top: 1px;}
		}
	}
	.wc-accept-terms-tooltip{min-width: 125px; min-height: 28px; line-height: 28px; font-size: 13px; color: white; display: none; position: absolute; left: -145px; top: 0; background: var(--primaryColor); text-align: center; padding: 0 10px; border-radius: 2px;
		&:after{.pseudo(6px,6px); top: 50%; margin-top: -3px; background: var(--primaryColor); right: -3px; transform: rotate(45deg);}
		&.active{display: block;}
		@media(max-width: 1440px){display: none !important;
			&.active{display: none;}
		}
	}
	.webshop-accept-terms1{
		@media (max-width: @tp){padding-bottom: 10px;}
	}

	.btn-final-payment{margin-bottom: 0; margin-right: 0; margin-top: 15px; width: auto; min-width: 245px;
		&.not-checked1,&.not-checked2{cursor: not-allowed;
			span{color: #aab1cb; }
		}
		@media (max-width: @t){margin-bottom: 10px; min-width: 180px;}
		@media (max-width: @m){margin-top: 5px; min-width: 100%;}
	}
</style>

<style lang="less">
	.page-checkout-step5{
		.wc-step1.completed-step{
			.step_link,.step_link2{padding-top: 0;}
		}
		.wc-subtitle{
			padding-top: 15px; padding-bottom: 15px !important;
			@media (max-width: @m){padding-bottom: 10px !important;}
		}
	}
</style>
